import { Card } from "antd";
import { Bar } from "react-chartjs-2";
import React, { useMemo } from "react";
import { ChartDataFeedback } from "../../chart-data-feedback";
import { useCompaniesByDimensions } from "../use-companies-by-dimensions";
import { BUSINESS_MODEL_CHART_OPTIONS } from "./business-model-chart-options";
import { businessModelToChart } from "./business-model-to-chart";

export const BusinessModelChart = ({ filters = {} }) => {
  const { loading, results } = useCompaniesByDimensions({
    dimensions: ["companyBussinessModel"],
    mustBeSet: ["companyBussinessModel"],
    ...filters
  });

  const chartData = useMemo(() => {
    if (!results) return ({ labels: [], datasets: [] });

    const [result] = results;
    return businessModelToChart(result.data);
  }, [results]);

  return (
    <Card
      spaced
      bordered
      style={sectionStyle}
      bodyStyle={{ height: "max-content" }}
      title="Compañías por modelo de negocio">
      <ChartDataFeedback
        loading={loading}
        isEmpty={!chartData?.datasets?.length}>
        <Bar
          height={300}
          type={"bar"}
          data={chartData}
          options={BUSINESS_MODEL_CHART_OPTIONS} />
      </ChartDataFeedback>
    </Card>
  );
};

const sectionStyle = {
  marginTop: 16,
  boxShadow: "none",
  borderRadius: "0"
};
